import { configureStore } from '@reduxjs/toolkit';

import patientReducer from './reducers/patient';
import documentsReducer from './reducers/documents';
import preferencesReducer from './reducers/preferences';
import globalsReducer from './reducers/globals';
import dictsReducer from './reducers/dicts';
import viewReducer from './reducers/views';
import userReducer from './reducers/user';
import wardReducer from './reducers/ward';
import notesReducer from './reducers/notes';
import externalLinksReducer from './reducers/externalLinks';
import additionalDataReducer from './reducers/additionalData';
import workflowReducer from './reducers/workflow';
import announcementReducer from './reducers/announcement';
import dragAndDropReducer from './reducers/dragAndDrop';
import bookedAdmissionsReducer from './reducers/booked_admissions';
import bedManagementReducer from './reducers/bedManagement';
import externalConfigReducer from './reducers/externalConfig';
import wardMapReducer from './reducers/wardMap';
import reviewReducer from './reducers/reviews';
import centralPageReducer from './reducers/centralPage';
import appointmentsReducer from './reducers/appointments';
import globalModalReducer from './reducers/globalModal';
import formsReducer from './reducers/formsAdditionalHelper';
import patientContextReducer from './reducers/patientContext';
import dashboardReducer from './reducers/dashboard';
import admissionReducer from './reducers/admission';
import patientListDataReducer from './reducers/patientListData';
import documentViewerReducer from '../components/docViewer/store/documentViewerReducer';
import cis2Reducer from './reducers/cis2';

// Middlewares
import dischargeMiddleware from './middleware/dischargeListenerMiddleware';

export default configureStore({
    reducer: {
        patient: patientReducer,
        documents: documentsReducer,
        documentViewer: documentViewerReducer,
        preferences: preferencesReducer,
        globals: globalsReducer,
        dicts: dictsReducer,
        views: viewReducer,
        user: userReducer,
        ward: wardReducer,
        reviews: reviewReducer,
        notes: notesReducer,
        externalLinks: externalLinksReducer,
        additionalData: additionalDataReducer,
        workflow: workflowReducer,
        announcement: announcementReducer,
        dragAndDrop: dragAndDropReducer,
        bookedAdmissions: bookedAdmissionsReducer,
        bedManagement: bedManagementReducer,
        externalConfig: externalConfigReducer,
        wardMap: wardMapReducer,
        centralPage: centralPageReducer,
        appointments: appointmentsReducer,
        patientContext: patientContextReducer,
        globalModal: globalModalReducer,
        forms: formsReducer,
        dashboard: dashboardReducer,
        admission: admissionReducer,
        patientListData: patientListDataReducer,
        cis2: cis2Reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).prepend(dischargeMiddleware),
});
